<template>
    <div class="info-tile">
        <InfoList :items="items" />
    </div>
</template>

<script setup>
import InfoList from "./InfoList.vue";

const props = defineProps({
    items: Object
});

</script>

<style lang="scss">
.info-tile {
    padding: 2vh;
}
</style>